// tslint:disable
/**
 * Course API
 * Used for: - Manage courses - Manage course info - Manage students - Learning control 
 *
 * The version of the OpenAPI document: 2.6.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface Session
 */
export interface Session {
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    lessonId: string;
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    lessonTitle: string;
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    status: SessionStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof Session
     */
    startedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Session
     */
    finishedAt?: Date;
}

/**
    * @export
    * @enum {string}
    */
export enum SessionStatusEnum {
    Process = 'process',
    Continue = 'continue',
    Success = 'success',
    Fail = 'fail',
    Abort = 'abort'
}



